import React, { Component } from 'react';
import Topbar from '../../components/common/Topbar';
import Footer from '../../components/common/Footer';
import ReportList from '../../components/reports/ReportList';


class ReportPage extends Component {
    render() {
        return (
            <>
                <div id="content-wrapper" className="d-flex flex-column master-page-layout">
                    <div id="content">

                        <Topbar />

                        <div className="container-fluid">

                            <ReportList />

                        </div>

                    </div>

                    <Footer />

                </div>
            </>
        );
    }

}

export default ReportPage;